import { Page } from "@/datastructures/Page";
import { PaginatedList } from "@/datastructures/PaginatedList";
import { FormRequestHandler } from "@/forms/FormRequestHandler";
import { FormResponse } from "@/forms/FormResponse";
import { SelectionItem } from "@/forms/ViewModelFormTypes";
import { OrderByClause, SortOrder } from "@/gateways/graphql/GraphQLConnection";
import { DateUtils } from "@/utils/DateUtils";
import { StockTakingGraphQLService } from "../services/StockTakingGraphQLService";
import { Store } from "../services/StoreGraphQLService";
import { StoreService } from "../services/StoreService";

export class StockTakingOverviewController {
  public constructor(
    private presenter: IStockTakingOverviewPresenter,
    private stockTakingService: StockTakingGraphQLService,
    private storeService: StoreService
  ) {}

  public mounted() {
    FormRequestHandler.handle(
      this.storeService.getAllStores(),
      response => (this.presenter.getStoresResponse = response),
      "Konnte Lagerorte nicht laden!"
    );

    this.getItems();
  }

  public parseDate(date: string) {
    return DateUtils.format(date);
  }

  public tableSorted(options: any) {
    this.presenter.options = options;

    if (!this.presenter.mounting) {
      this.getItems();
    }
  }

  public pageChanged(newPageNumber: number) {
    this.presenter.pageNumber = newPageNumber;

    if (!this.presenter.mounting) {
      this.getItems();
    }
  }

  private getItems() {
    const order: OrderByClause[] = [];
    for (let i = 0; i < this.presenter.options.sortBy.length; i++) {
      order.push({
        field: this.presenter.options.sortBy[i],
        order: this.presenter.options.sortDesc[i]
          ? SortOrder.DESC
          : SortOrder.ASC
      });
    }

    const page = new Page(
      this.presenter.itemsPerPage,
      this.presenter.pageNumber
    );

    FormRequestHandler.handle(
      this.stockTakingService.getAllStockTakingsPaginated(
        page,
        order,
        this.presenter.search,
        this.presenter.storeFilter.selected
      ),
      response => (this.presenter.tableRequest = response),
      "Konnte Tabelle nicht laden!"
    );
  }
}

export interface IStockTakingOverviewPresenter {
  mounting: boolean;
  getStoresResponse: FormResponse<Store[]>;
  tableRequest: FormResponse<PaginatedList<any>>;

  storeFilter: {
    selected: string[];
    items: SelectionItem[];
  };

  pageNumber: number;
  itemsPerPage: number;
  options: any;
  search: string;
}
